/**
 * 쿼리 실행 모니터링 API — 편집기 세션에서 지금 실행 중인 문장의 스냅샷 한 장(백엔드 database/execMonitor.js).
 * 자기 세션만 본다(남의 세션 id 는 404). monitor·ash 는 라이선스 팩이 필요한 소스라 켠 것만 서버가 조회한다.
 */
import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_BASE_URL || '/sql-developer';

/** { supported, running, session, exec, planText?, lines, stmt?, notes } */
export async function execMonitorSnapshot(sessionId, { monitor = false, ash = false, withPlan = false } = {}) {
  return (await axios.post(`${BASE_URL}/sessions/${encodeURIComponent(sessionId)}/exec-monitor`, { monitor, ash, withPlan })).data;
}

/**
 * 방금 실행한 문장의 **실측 실행계획**(DBMS_XPLAN.DISPLAY_CURSOR — 다시 실행하지 않는다). `sql` 은 그 문장이 맞는지 견주는 데만 쓰인다.
 * { rows:[{PLAN_TABLE_OUTPUT}], exec, statisticsLevel, hasRowStats } — 못 집으면 409 + errorType
 */
export async function lastActualPlan(sessionId, sql) {
  return (await axios.post(`${BASE_URL}/sessions/${encodeURIComponent(sessionId)}/last-plan`, { sql })).data;
}

/** 방금 실행한 문장의 SQL Monitor 리포트(TEXT). **Tuning Pack 기능 — 사용자가 단추를 눌렀을 때만 부른다.** { report, exec, pinned } */
export async function lastSqlMonitorReport(sessionId, sql) {
  return (await axios.post(`${BASE_URL}/sessions/${encodeURIComponent(sessionId)}/sql-monitor-report`, { sql })).data;
}
